<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Cities</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Cities
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="addCityModal" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    Add City
                </button>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Cities</h4>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="city-search"
                        placeholder="Search by city name"
                        show-filters
                        @apply="applyFilters"
                        @reset="resetFilters"
                    >
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="city-state">By State</label>
                                <select id="city-state" class="form-control form-control-sm" v-model="filters.state_id">
                                    <option :value="null">All</option>
                                    <option v-for="state in states" :key="state.id" :value="state.id">
                                        {{ state.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </list-controls>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allCities"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#"
                                   class="dropdown-item"
                                   @click.prevent="editCityModal(props.row.name, props.row.state_id, props.row.id )">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade add-city-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="addCity">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                            {{ this.isEditing ? "Edit" : "Add" }} City</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label class="form-label">State</label>
                                <select v-model="city.state_id" id="" class="form-control" required>
                                    <option :value="null">Select a State</option>
                                    <option v-for="state in states" :key="state.id"
                                            :value="state.id">
                                        {{ state.name }}
                                    </option>
                                </select>
                                <span v-if="city.errors.state_id"
                                      class="text-danger text-small">{{ city.errors.state_id }}</span>
                            </div>

                            <div class="form-group"><label>City Name</label>
                                <input type="text" required="required" v-model="city.name"
                                       class="form-control">
                                <div v-if="city.errors.name" class="text-danger text-small">
                                    {{ city.errors.name }}
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../../Shared/Mixins/ListQueryMixin";

export default {
    metaInfo: {title: 'Cities'},
    props: [
        'cities',
        'states',
    ],
    layout: Layout,
    components: {
        Link,
        ListControls,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        ListQueryMixin,
    ],
    data() {
        return {
            city: this.$inertia.form({
                name: null,
                state_id: null,
                id: null,
            }),
            filters: {
                state_id: null,
            },
            isLoadingFilter: false,
            allCities: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'City Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'State', field: 'state_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
            saving: false,
            isEditing: false,
        }
    },

    mounted() {
        this.allCities = this.cities.data;
        this.totalRecords = this.cities.total
    },

    methods: {
        addCityModal() {
            $('.add-city-modal').modal('show');
            this.city.name = "";
            this.city.state_id = "";
            this.isEditing = false;
        },

        async editCityModal(name, stateId, resourceId) {
            this.city.name = name;
            this.city.state_id = stateId;
            this.isEditing = true;
            this.city.id = resourceId
            $('.add-city-modal').modal('show');
        },

        async addCity(id = null) {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('.add-city-modal').modal('hide');

                },
                onError: () => {
                    this.saving = false;
                }
            };
            this.isEditing ?
                this.city.put(route('admin.stores.cities.update', this.city.id), options)
                :
                this.city.post(route('admin.stores.cities.store'), options);

            await this.paginatedData();
        },

        paginatedData() {
            return this.loadList('admin.stores.cities.index', 'allCities');
        },
        async deleteCity(id) {
            await this.$inertia.delete(route('admin.stores.cities.delete', id), {
                preserveScroll: true,
                onSuccess: async() => {
                    await this.paginatedData();
                }
            })
        },
        async showAlert(cityId) {
            const details = {
                title: "Are you sure you want to delete this city?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteCity(cityId) : "";
        },
    }
}
</script>
